// extracted by mini-css-extract-plugin
module.exports = {"cardsWrap":"styles_cardsWrap__Vu_au","cardWrap":"styles_cardWrap__3IbEK","title":"styles_title__1ExT6","Circle":"styles_Circle__yypXJ"};